/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */

/* eslint-enable no-console */

    // // 1. Создаем основной элемент div
    // const loadingOverlay = document.createElement('div');
    // loadingOverlay.id = 'wn-loading-overlay';
    // loadingOverlay.style.display = 'none'; // Изначально скрыт

    // // 2. Создаем div для спиннера
    // const spinner = document.createElement('div');
    // spinner.className = 'spinner';

    // // 3. Создаем div для области сообщения
    // const messageArea = document.createElement('div');
    // messageArea.className = 'message-area';

    // // 4. Добавляем спиннер и область сообщения в loadingOverlay
    // loadingOverlay.appendChild(spinner);
    // loadingOverlay.appendChild(messageArea);

    // // 5. Добавляем loadingOverlay в конец тега <body>
    // document.body.appendChild(loadingOverlay);

    // console.log('Loading overlay added to the body.');
